import { confirmAction, GeoSearch } from '@seims/shared';
import { Button, Col, Form, Input, Modal, Select, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import area from "../../data/Location";
// import { util } from "../../utils/functions/custom";
import { util } from "@seims/shared";

export const AddressControl = ({
  title,
  onCancel,
  visible,
  isLocal,
  onModalSubmit,
  address = {},
  requireSearchFirst = false,
}) => {
  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const DEFAULT_LAT = util.getEnvVariable("REACT_APP_DEFAULT_LAT");
  const DEFAULT_LON = util.getEnvVariable("REACT_APP_DEFAULT_LON");
  const DEFAULT_PROVIDER = util.getEnvVariable("REACT_APP_GEOSEARCH_PROVIDER");

  const [hasSearched, setHasSearched] = useState(!requireSearchFirst);

  const formName = "AddressForm";
  const [form] = Form.useForm();
  const { Option } = Select;

  const [provinces] = useState([
    ...area.provinces.sort(util.setDynamicSort("text")),
  ]);

  const [countries] = useState([
    ...area.countryList.sort(util.setDynamicSort("text")),
  ]);

  const geoLookupRef = useRef(null);

  const hasFormValues = () => {
    const values = form.getFieldsValue();
    return Object.values(values).some(
      (v) => v !== undefined && v !== null && v !== ""
    );
  };

  const updateFormWithLocation = (lat, lon, structured) => {
    form.setFieldsValue({
      x: Number(lat),
      y: Number(lon),
      postalCode: structured?.postcode,
      cityOrTown: structured?.city,
      street: structured?.street,
      country: structured?.country,
      province: structured?.state ?? structured?.province ?? null,
    });
  };

  const handleLocationUpdate = (locationData) => {
    updateFormWithLocation(
      locationData.lat,
      locationData.lon,
      locationData.structured
    );

    if (requireSearchFirst) setHasSearched(true);
  };

  useEffect(() => {
    if (!visible) return;

    if (!util.isEmpty(address)) {
      loadAddress();
      setHasSearched(true);
    } else {
      form.resetFields();
      setHasSearched(!requireSearchFirst);

      if (isLocal) {
        const selectedCountry = countries.find(
          (record) => record.value === "South Africa"
        );
        form.setFieldsValue({ country: selectedCountry });
      }
    }
  }, [visible, address]);

  const loadAddress = () => {
    form.setFieldsValue({
      street: address.street,
      cityOrTown: address.cityOrTown,
      postalCode: address.postalCode,
      province: address.province,
      country: address.country,
      x: address.x,
      y: address.y,
    });
  };

  const onSubmit = (values) => {
    form.resetFields();
    onModalSubmit(values);
  };

  // NEW: centralized confirm logic
  const handleCancelRequest = () => {
    if (!hasFormValues()) {
      onCancel();
      return;
    }

    confirmAction({
      title: "Are you sure you want to cancel?",
      description: "You will lose all entered information.",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        form.resetFields();
        setHasSearched(!requireSearchFirst);
        onCancel();
      },
    });
  };

  const onNameBlur = (e) => {
        const { value, name } = e.target;
        console.log("VENUE", name, value);
        const textValue = util.toPascalText(value);
        form.setFieldsValue({ [name]: textValue });
      }
    

  return (
    <Modal
      title={title}
      open={visible}
      maskClosable={false}
      keyboard={false}
      onCancel={handleCancelRequest}
      footer={[
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>

          <Button onClick={handleCancelRequest}>
            Cancel
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            form={formName}
            disabled={requireSearchFirst && !hasSearched}
          >
            Confirm
          </Button>
        </div>,
      ]}
    >
      <Form
        {...formItemLayout}
        name={formName}
        form={form}
        layout="horizontal"
        onFinish={onSubmit}
      >
        {requireSearchFirst && !hasSearched && (
          <div style={{ marginBottom: 16 }}>
            <div
              style={{
                padding: 12,
                borderRadius: 6,
                background: "#e6f4ff",
                border: "1px solid #91caff",
                color: "#0958d9",
                fontSize: 14,
              }}
            >
              🔍 <b>Start by searching for an address</b><br />
              Use the search bar below to find a location. Once selected, you can refine the address details.
            </div>
          </div>
        )}

        <Row style={{ marginBottom: 24 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <GeoSearch
              ref={geoLookupRef}
              onDataUpdate={handleLocationUpdate}
              defaultCenter={[DEFAULT_LAT, DEFAULT_LON]}
              defaultProvider={DEFAULT_PROVIDER}
              sessionToken={crypto.randomUUID()}
              regionCode={isLocal ? "za" : " "}
            />
          </Col>
        </Row>
        <Form.Item hidden
          name="id"
        >
          <Input />
        </Form.Item>
        <Form.Item name="country" label="Country">
          <Select disabled={requireSearchFirst && !hasSearched}
            rules={[{ required: true, message: "Please select a country" }]}>
            {countries.map((country) => (
              <Option key={country.value}>{country.text}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="street" label="Street Address"
          rules={[{ required: true, message: "Please enter street address" }]}>
          <Input disabled={requireSearchFirst && !hasSearched} />
        </Form.Item>

        <Form.Item name="cityOrTown" label="Town/City"
          rules={[{ required: true, message: "Please enter town/city" }]}>
          <Input disabled={requireSearchFirst && !hasSearched} name="cityOrTown" onBlur={onNameBlur} />
        </Form.Item>

        <Form.Item name="province" label="Province/State"
          rules={[
            { required: true, message: "Please select a province/state" },
          ]}>
          <Select disabled={requireSearchFirst && !hasSearched}>
            {provinces.map((province) => (
              <Option key={province.value}>{province.text}</Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="postalCode" label="Postal Code"
          rules={[{ required: true, message: "Please enter postal code" }]}>
          <Input
            style={{ width: 100 }}
            minLength={4}
            maxLength={6}
            disabled={requireSearchFirst && !hasSearched}
          />
        </Form.Item>
        <Form.Item hidden
          name="x"
        // label="Latitude"
        >
          <Input />
        </Form.Item>
        <Form.Item hidden
          name="y"
        // label="Longitude"
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
